/* eslint-disable max-len */
import React, { memo } from 'react'
import map from 'ramda/src/map'
import length from 'ramda/src/length'
import identity from 'ramda/src/identity'
import add from 'ramda/src/add'
import slice from 'ramda/src/slice'
import classNames from 'classnames'
import Slider from 'root/src/client/web/base/Slider'
import { useWindowSize } from 'root/src/client/v2/common/hooks/useWindowSize'
import { comparePropsFn } from 'root/src/shared/util/stateCompare'
import Assignee from './Assignee'
import assigneesLogic from './assigneesLogic'

const AssigneesSection = memo(({
	classes, assignees, isMobileRes, projectDeliveries,
}) => {
	const [width] = useWindowSize()
	const assigneeLength = length(assignees)
	const dareStatus = !!projectDeliveries
	const handlerProps = { width, isMobileRes, assigneeLength, dareStatus }
	const { scrollItemBreakpoints, scrollItemArrowBreak, stepMultiplier, dragActive } = assigneesLogic(handlerProps)
	const breakPoint = scrollItemBreakpoints()
	const maxAssignees = slice(0, add(breakPoint, 0), assignees)
	return (
		<div className={classes.assigneesWrapper}>
			<section className={
				projectDeliveries
					? classes.completedDareAssigneesSection : classes.assigneesSection}
			>
				<div className={classNames(classes.assigneesContainer)}>
					<h4 className={classes.steamerChallenged}>Creator challenged {`(${assigneeLength})`}</h4>
					<Slider
						captions
						arrows={(!isMobileRes && breakPoint < assigneeLength)}
						sliderItemsStyle={classes.sliderAssignees}
						scrollItemBreakpoints={scrollItemArrowBreak()}
						stepMultiplier={stepMultiplier()}
						isMobileRes={isMobileRes}
						showItems={isMobileRes ? assigneeLength : length(maxAssignees)}
						sliderItems={maxAssignees}
						renderSliderItem={() => identity}
						sliderWidth
						dragActive={dragActive()}
						smoothDrag
						assigneesArrow
						layoutRow
						assigneesOverflow={!isMobileRes}
					>
						{map(assignee => <Assignee {...assignee} key={assignee.platformId} />, maxAssignees)}
					</Slider>
				</div>
			</section>
		</div>
	)
})

export default memo(AssigneesSection, comparePropsFn([
	'classes', 'assignees', 'isMobileRes', 'projectDeliveries',
]))
